// NewComer/CoinManager.ts
import RandomUtil from '@/Master/RandomUtil';
import {gsap} from 'gsap';
import {MotionPathPlugin} from 'gsap/MotionPathPlugin';
import Util from "@/Master/Util";
import {RewardType} from "@/Core/Reward/RewardInfo";

gsap.registerPlugin(MotionPathPlugin);

export interface CoinOptions {
    rewardType: RewardType;
    index: number;
    target: HTMLElement;
    onComplete?: (index: number) => void;
}

class CoinManager {
    private container: HTMLElement;
    private windowCenter = { centerX: window.innerWidth / 2, centerY: window.innerHeight / 2 };

    constructor() {
        const container = document.getElementById('effectPanel');
        if (!container) {
            throw new Error(`Container with id not found.`);
        }
        this.container = container;

        // 监听窗口大小变化
        window.addEventListener('resize', this.updateWindowCenter);
    }

    private updateWindowCenter = () => {
        this.windowCenter = { centerX: window.innerWidth / 2, centerY: window.innerHeight / 2 };
    };

    async createCoins(type: RewardType, count: number, targetDom: HTMLElement,complete:(index:number)=>void) {
        for (let i = 0; i < count; i++) {
            const index = i;
            const delay = 0.1 + i * 0.01;
            const coinOptions: CoinOptions = {
                rewardType: type,
                index: 0,
                target: targetDom,
                onComplete: (ind) => {
                    // if (index == count-1){
                    //     console.log(`index=${index}`);
                    //
                    // }
                    complete(index);
                }
            };
            await this.createFlyCoin(coinOptions);
            // 等待延迟
            await this.delay(10);
        }
    }

    private delay(ms:number) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }

    async createFlyCoin(options: CoinOptions) {
        const { target, onComplete } = options;

        // 创建金币元素
        const coin = document.createElement('img');
        if (options.rewardType == RewardType.SC){
            coin.src ='/img/ico_sc.png';
        }else{
            coin.src ='/img/ico_gc.png';
        }
        coin.alt = 'Gold Coin';
        coin.style.width = '0.8rem';
        coin.style.height = '0.8rem';
        coin.style.borderRadius = '50%';
        coin.style.position = 'fixed';
        coin.style.left = `${this.windowCenter.centerX}px`;
        coin.style.top = `${this.windowCenter.centerY}px`;
        coin.style.pointerEvents = 'none';
        coin.style.zIndex = '1000';
        coin.style.transform = 'translate(-50%, -50%)';
        this.container.appendChild(coin);

        // 获取目标元素的中心位置
        const getTargetPosition = () => {
            const targetRect = target.getBoundingClientRect();
            const centerX = targetRect.left + targetRect.width / 2;
            const centerY = targetRect.top + targetRect.height / 2;
            return { centerX, centerY };
        };

        // 获取飞入目标的位置
        const endFlyPosition = () => {
            const { centerX: targetCenterX, centerY: targetCenterY } = getTargetPosition();
            const { centerX: windowCenterX, centerY: windowCenterY } = this.windowCenter;

            const flyX = targetCenterX - windowCenterX;
            const flyY = targetCenterY - windowCenterY;

            return { flyX, flyY };
        };

        const centerX = this.windowCenter.centerX;
        const centerY = this.windowCenter.centerY;
        const tPos = getTargetPosition();
        const endPos = endFlyPosition();
        const endX = endPos.flyX;
        const endY = endPos.flyY;


        // 随机散开的方向和距离
        const randAngle = RandomUtil.fromTo(0, 18) * 10 * Math.PI;
        const scatterX = Math.cos(randAngle) * RandomUtil.fromTo(8, 25) * 6;
        const scatterY = Math.sin(randAngle) * RandomUtil.fromTo(8, 25) * 6;

        if (Util.isLog){
            // console.log(`centerX=${centerX},centerY=${centerY},endX=${endX},endY=${endY},scatterX=${scatterX},scatterY=${scatterY}`);
        }

        // 动画时间
        const scatterDuration = 0.3;
        const flyDuration = 1.5;

        // 创建时间线
        const tl = gsap.timeline({
            onComplete: () => {
                if (onComplete) {
                    onComplete(options.index);
                }
            },
        });

        // 散开动画
        tl.to(coin, {
            duration: scatterDuration,
            ease: 'power2.out',
            motionPath: {
                path: [
                    { x: 50, y: 50 }, // 起点
                    { x: 10, y: 10 }, // 控制点 1
                    { x: scatterX, y: scatterY }  // 终点
                ],
                curviness: 1.5,         // 曲线平滑度
                autoRotate: true,       // 自动旋转
            }

        })
        // 飞入目标元素的动画，使用 MotionPathPlugin
        .to(coin, {
            duration: flyDuration,
            motionPath: {
                path: [
                    { x: scatterX-RandomUtil.fromTo(10,50), y: scatterY+RandomUtil.fromTo(10,50)},
                    { x: endPos.flyX+RandomUtil.fromTo(10,50), y: endPos.flyY+RandomUtil.fromTo(10,50) }, // 控制抛物线高度
                    { x: endPos.flyX, y: endPos.flyY },
                ],
                curviness: 1.5,
                autoRotate: false,
            },
            ease: 'power2.in',
        })
        // 缩放并移除
        .to(coin, {
            duration: 0.2,
            scale: 1.1,
        })
        .to(coin, {
            duration: 0.2,
            scale: 1.5,
            opacity: 0,
            onComplete: () => {
                if (coin.parentNode) {
                    coin.parentNode.removeChild(coin);
                }
            },
        })

    }

    destroy() {
        // 移除窗口大小监听
        window.removeEventListener('resize', this.updateWindowCenter);
    }
}

export default CoinManager;
